// @flow
import * as React from "react";
import type { TicketReservation } from "../../common/types";
import List from "@material-ui/core/List";
import GameAdminSmartCheckInFormListItem from "./GameAdminSmartCheckInFormListItem";
import { Suspense, useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import Skeleton from "@material-ui/lab/Skeleton";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import _ from "lodash";
import Fuse from "fuse.js";
import SearchIcon from "@material-ui/icons/Search";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
type Props = {
  ticketReservations: Array<TicketReservation>,
  setTicketReservation: Function,
  setStep: Function,
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
}));

function GameAdminSmartCheckInFormList({
  ticketReservations,
  setTicketReservation,
  setStep,
}: Props) {
  const classes = useStyles();
  const [query, updateQuery] = useState("");

  const onSearch = ({ currentTarget }) => {
    updateQuery(currentTarget.value);
  };

  const ticketReservationsSorted = _.orderBy(
    ticketReservations,
    ["userName"],
    ["asc"]
  );

  const fuse = new Fuse(ticketReservationsSorted, {
    keys: ["userName"],
  });

  const results = fuse.search(query);
  const resultItems = Boolean(query)
    ? results.map((c) => c.item)
    : ticketReservationsSorted;

  return (
    <>
      <Paper className={classes.root}>
        <IconButton
          className={classes.iconButton}
          aria-label="search"
          onClick={() => {}}
        >
          <SearchIcon />
        </IconButton>
        <InputBase
          className={classes.input}
          placeholder="Liste durchsuchen"
          onChange={onSearch}
        />
      </Paper>
      <List>
        {resultItems.map((tr) => (
          <Suspense
            key={tr.id}
            fallback={
              <ListItem>
                <ListItemText
                  primary={<Skeleton width="100%" />}
                  secondary={<Skeleton width="100%" />}
                />
              </ListItem>
            }
          >
            <GameAdminSmartCheckInFormListItem
              ticketReservation={tr}
              setTicketReservation={setTicketReservation}
              setStep={setStep}
            />
            <Divider />
          </Suspense>
        ))}
      </List>
    </>
  );
}

export default GameAdminSmartCheckInFormList;
